/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const layout_card_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#layout_card_medium_svg__a)"
      clipRule="evenodd"
    >
      <path d="M1 3.276A2.276 2.276 0 0 1 3.276 1h17.448A2.276 2.276 0 0 1 23 3.276v4.248A2.276 2.276 0 0 1 20.724 9.8H3.276A2.276 2.276 0 0 1 1 7.524V3.276Zm0 13.2A2.276 2.276 0 0 1 3.276 14.2h17.448A2.276 2.276 0 0 1 23 16.476v4.248A2.276 2.276 0 0 1 20.724 23H3.276A2.276 2.276 0 0 1 1 20.724v-4.248Z" />
    </g>
    <defs>
      <clipPath id="layout_card_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default layout_card_medium
